import { DEFAULT_SESSION } from "../constant"

export interface SessionLike {
  _id: string
  openForRegistration?: boolean
}

// Picks which session should be "current" when nothing has been explicitly
// selected yet: the configured default if present, else whichever session
// is flagged open-for-registration (the one field admins can actually and
// reliably toggle — the old `isActive` boolean this used to check was
// silently dead: the backend schema dropped it in favor of `status` years
// ago, so it was never persisted for any session created since, and only
// produced a real value for a handful of pre-migration legacy documents —
// which is exactly what picked the wrong "current" session for Eon), else
// the first one. Single source of truth — used by sessionsSlice's
// restore-on-load logic and by login's enrollment lookup, so the two can
// never resolve a different "current" session from each other.
export const resolveDefaultSessionId = <T extends SessionLike>(sessions: T[]): string | null => {
  const open = sessions.find((s) => s.openForRegistration)
  if (open) return open._id
  if (DEFAULT_SESSION) {
    const match = sessions.find((s) => s._id === DEFAULT_SESSION)
    if (match) return match._id
  }
  return sessions[0]?._id ?? null
}
